module.exports = __webpack_public_path__ + "media/ll.e0bfc26d.mp3";